<template>
  <div v-if="data">
    <p class="h-4 bg-mainGray mt-8 -mx-8 mb-5 text-left"></p>
    <h1 class="font-bold text-1.125rem text-left">{{ $t("订单评论") }}</h1>
    <div class="text-left">
      <div class="flex pt-4 space-x-4">
        <img
          :src="$firstImage(data.images, 'small')"
          class="w-40 h-40 img"
          v-if="data.images"
          :onerror="defaultUrl"
        />
        <div class="space-y-5 h-20">
          <span class="pr-4">{{ $t("评分") }}</span>
          <el-rate disabled class="inline-block" :value="data.score"></el-rate>
          <p class="text_display">
            {{ data.content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },
  setup() {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    return { defaultUrl };
  },
};
</script>
<style scoped lang="scss">
.text_display {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>
